import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const AppleIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Frame 1000005797">
        <path
          id="Vector"
          d="M18.0709 6.92423C17.9722 6.98369 15.801 8.21888 15.8256 10.7886C15.8529 13.8622 18.5831 14.8857 18.6145 14.8973C18.59 14.9705 18.178 16.3551 17.1753 17.7851C16.3088 19.0239 15.4112 20.2557 13.9945 20.2814C12.6027 20.3063 12.1541 19.4745 10.5641 19.4745C8.97313 19.4745 8.47515 20.2557 7.15895 20.3064C5.79154 20.3569 4.75048 18.9686 3.87759 17.7365C2.09316 15.2152 0.728818 10.611 2.56081 7.50389C3.47031 5.96078 5.09594 4.98316 6.85978 4.95791C8.20308 4.9331 9.46992 5.84029 10.2916 5.84029C11.1015 5.84029 12.5531 4.78276 14.2641 4.90644C14.9347 4.95501 16.8384 5.15058 18.0709 6.92423ZM13.2084 3.24201C13.9351 2.38385 14.424 1.18872 14.2894 0C13.2435 0.040528 11.9785 0.680736 11.2284 1.53835C10.5566 2.29806 9.96659 3.51483 10.1268 4.67928C11.2925 4.7673 12.4823 4.1007 13.2084 3.24201Z"
          fill={fillColor || '#9D9DA6'}
        />
      </g>
    </svg>
  );
};

export { AppleIcon };
